module.exports = __webpack_public_path__ + "img/ps_Android.03cd85fa.png";